module.exports = __webpack_public_path__ + "img/first-component-web.f1d5276c.webp";